<div [class.dark-mode]="this.isDark" (click)="getClick()" class="ramadan-header">
    <img [src]="this.getSource()" width="100%" />
</div>
<audio id="ramadan-audio" hidden src="https://cdn1.esm3.com/music/460/m17315.mp3"></audio>
